import PrivacySelector from './PrivacySelector'

export default PrivacySelector
